import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { ErrorDetailsService } from 'bi-modules';
import { AuthService } from '../core/auth.service';
import { SBHttpServicesService } from '../shared/services/sbhttp-services.service';
import { UserInfo } from '../userInfo';
import { ShareDataService } from '../shared/services/ShareDateService';
import { Router } from '@angular/router';
import { MenuItemsService } from '../shared/services/menu-items/menu-items.service';
import { SignalRHelperService } from '../shared/services/SignalRHelper.service';
import { FavoriteScreensService } from '../shared/services/favorite-screens.service';
import { RecentScreensService } from '../shared/services/RecentScreensService/recent-screens.service';
import { ClientAppUserUIProfileService } from '../shared/services/client-app-user-uiprofile.service';
import { combineLatestWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private HttpHeader = { skip: "true" };
  public isLoggedIn: boolean = true;
  public userData;

  constructor(private httpService: HttpService,
    private environment: AppConfigService,
    private errorDetailsService: ErrorDetailsService,
    private _authService: AuthService,
    private SBHttpService: SBHttpServicesService,
    private _shareDataService: ShareDataService,
    private router: Router,
    private menuItemsService: MenuItemsService,
    private favoriteScreensService: FavoriteScreensService,
    private recentScreensService: RecentScreensService,
    private clientAppUserUIProfileService: ClientAppUserUIProfileService,
    private signalRHelper: SignalRHelperService) {}

  getLoginParams() {
    return this.httpService.get('VU_ConfigParams');
  }

  getCompanyImages() {
    return this.httpService.get('SA_CompanyImages?Filter=ImageType eq 0 and IsCurrent eq true',
      this.HttpHeader);
  }

  getBusinessUnits(user) {
    return this.httpService.get(`HH_SA_UserBUPermissions?$expand=HH_SA_BU($select=Description,DescriptionA),loginusers($select=userName)&$filter=loginusers/email eq '${user}' or userID eq '${user}'&$select=Buid`);
  }

  RegenerateSSOToken(SSOToken: string, newBUID: string, newLanguage: string) {
    return this.httpService.add('RegenerateSSOToken', {
      Token: SSOToken,
      NewBUID: newBUID,
      NewLanguage: newLanguage
    });
  }

  RemoveLocalStorageTokens() {
    localStorage.removeItem("userinfo");
    localStorage.removeItem("jwt");
    localStorage.removeItem("refreshToken");
  }

  setLoginClaims(userData, creds, buDefaultItem) {
    this.userData = userData;
    this.setClaims(creds, buDefaultItem);
    this.httpService.get('HH_Params?$filter=Param_ID eq 7153').subscribe(res => {
      this.environment.apiKey = res.value[0].PARAM_VALUE

    })
    this.getPrecision();
  }

  async setClaims(creds, buDefaultItem) {
    this.errorDetailsService.ErrorMessagesQueue = [];
    this.LoadUserClaims(creds, buDefaultItem);
    let RequestBody = { "Token": this.userData.token };
    var encodedUser = await this.SBHttpService.httpPostRequestUnAuthorized(`${this.environment.oDataApi}/GetLoginUserEncoded`, RequestBody)
    localStorage.setItem("EncodedUser", encodedUser.data);
  }

  getPrecision() {
    this.httpService.get('HH_PARAMS?$filter=PARAM_ID eq 38&$select=PARAM_ID,PARAM_VALUE').subscribe(
      {
        next(value: any) { localStorage.setItem("Precision", value.value[0].PARAM_VALUE) },
        error(err) { console.error('Observable emitted an error: ' + err); },
      }
    )
  }

  RedirectToHome() {
    var RedirectUrl = window.location.href.replace('login', '');

    if (localStorage.getItem('redirectTo')) {
      RedirectUrl = localStorage.getItem('redirectTo').replace('login', '');
    }

    if (UserInfo.Language == 1) {
      this._shareDataService.isUserLoggedIn.next(true);
    }
    else {
      this._shareDataService.isUserLoggedIn.next(true);
    }
    window.location.href = RedirectUrl;

  }

  LoadUserClaims(creds, buDefaultItem) {
    var user = creds;
    user.ODataToken = this.userData.token;
    user.Token = this.userData.token;
    user.UserCode = this.userData.userCode;
    user.refreshToken = this.userData.RefreshToken;
    user.BusinessUnitName = creds.BusinessUnitName != '' ? creds.BusinessUnitName : buDefaultItem.Description;
    user.BusinessUnitAName = creds.BusinessUnitAName != '' ? creds.BusinessUnitAName : buDefaultItem.DescriptionA;
    this._authService.loadUserClaims(user);
  }

  ClearSSOCookies() {
    // We cannot override or update the cookies since the website is secured (https), so we deleted the cookies from the backend.
    return this.httpService.add('ClearSSOCookies', {});
  }
}
